import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Button } from "../../../ui/Credit/Button/Button";
import { Container } from "../../../ui/Credit/Container/Container";
import { QuestionList } from "../../../Data/QuestionData";
import { Item } from "../../../ui/Credit/Item/Item";
import { Progress } from "../../../ui/Credit/Progress/Progress";
import { useRecoilState } from "recoil";
import { resultState } from "../../../Data/Recoil";
import { isMobile } from "react-device-detect";
import Explanation from "../../../ui/Credit/Explanation/Explanation";

const Title = styled.h2`
  width: 328px;
  font-size: 24px;
  margin: 32px 0;
  text-align: left;
`;

const Box = styled.div`
  width: 100%;
  min-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: ${isMobile && 'relative' || 'fixed'};
  bottom: 0;
`;

const Question = () => {
  const [resultValue, setResultValue] = useRecoilState(resultState);
  const [location, setLocation] = useState([{page: 1, step: 0}]);
  const [move, setMove] = useState(false);
  const [page, setPage] = useState(1);
  const [step, setStep] = useState(0);
  const [active, setActive] = useState(null);
  const progress = useMemo(() => page, [page && move]);
  const data = useMemo(() => 
    QuestionList.find((elem) => {
      return page !== "checkList" ? elem.page === page && elem.step == step : elem.page === page }
    ), [page && move]
  );

  useEffect(() => {
    if (location.indexOf(page) === -1) {
      setLocation([...location, { page: page, step: step }]);
    }
  }, [page && move]);

  const pageMove = () => {
    let locationData = location[location.indexOf(location.find((elem) => elem.page == data.page)) - 1];

    setActive(null);
    setPage(locationData.page);
    setStep(locationData.step);
    setMove(!move);
  };

  const setValue = (v) => {
    if (location[location.length-1].page === "checkList") {
      let value = resultValue.length >= 3 ? resultValue.toString().slice(0, -1) : resultValue;
      setResultValue(`${value}`+`${v}`);
    } else {
      setResultValue(v);
    }
  };

  return (
    <Container className="App-question">
      <div className="App-layout">
        <Progress page={progress} />
        <Title>{data.title}</Title>
        {data.list.map((elem) => {
          return (
            <Item
              h={55}
              key={elem.id}
              id={elem.id}
              className={`q-item ${
                Number(active) === Number(elem.id) ? `active` : ""
              }`}
              onClick={() => {
                setActive(elem.id);
                setStep(elem.id);
                setPage(elem.next);
                setValue(elem.id);
              }}
            >
              {elem.text}
            </Item>
          );
        })}

        <Explanation page={location[location.length-1].page} />

        <Box>
          {Number(data.page) === 1 ? (
            <Link to={"/"}>
              <Button width={328 / 2} className="question-prev">
                이전
              </Button>
            </Link>
          ) : (
            <Button
              width={328 / 2}
              className="question-prev"
              onClick={() => pageMove()}
            >
              이전
            </Button>
          )}

          {page === "result" ? (
            <Link to={"/credit/result"}>
              <Button width={328 / 2} bg={"#6c15a7"} color={"#fff"}>
                다음
              </Button>
            </Link>
          ) : (
            <Button
              width={328 / 2}
              bg={"#6c15a7"}
              color={"#fff"}
              onClick={() => {
                setMove(!move);
              }}
            >
              다음
            </Button>
          )}
        </Box>
      </div>
    </Container>
  );
};

export default Question;
